import React, { FC } from 'react'
import { useSelector } from 'react-redux'
import { currentUserSelector } from '../../auth/authSelectors'
import ManagerBranchesPicker from '../../manager/common/ManagerBranchesPicker'
import { NavLink } from 'react-router-dom'
import ManagerAccountsPicker from '../../manager/common/ManagerAccountsPicker'

const SubHeaderManager: FC = () => {
  const currentUser = useSelector(currentUserSelector)
  return (
    <>
      <ManagerAccountsPicker className="header_picker" />
      <ManagerBranchesPicker className="header_picker" />
      {currentUser.enableReports && (
        <NavLink
          activeClassName="-active"
          className="menu_root-link link"
          to="/powerbi"
        >
          Reports
        </NavLink>
      )}
      <div className="header_separator" />
    </>
  )
}

export default SubHeaderManager
